import React from "react";
import Hero from "../components/Hero";
import HeroImage from "../../assets/images/PrivacyPage.jpg";
import "../../css/PrivacyPage.css";

function TermsAndConditionsPage() {
  return (
    <>
      <Hero
        title={"Terms & Conditions"}
        subtitle={""}
        backgroundImage={HeroImage}
      />
      {/* <div className="address-section">
        <div className="address-card">
          <h4>Correspondence Address</h4>
          <p>
            Arum House,
            <br />
            21 Mill Rise, Robertsbridge,
            <br />
            East Sussex,
            <br />
            TN32 5EF
          </p>
        </div>

        <div className="address-card">
          <h4>FCA Registered Address </h4>
          <p>Rosemount House<br/>2–4 Chequers Road <br/>Basingstoke <br/>RG21 7PU </p>
        </div>
      </div> */}

      <div className="privacy-container">
        <h3>1. Promoter</h3>{" "}
        <p>
          {" "}
          Ava Rose Mortgages Ltd is an Appointed Representative of Rosemount
          Financial Solutions (IFA) Ltd which is authorised and regulated by the
          Financial Conduct Authority. Rosemount Financial Solutions (IFA) Ltd
          is entered on the Financial Services Register under reference 535515.
          Ava Rose Mortgages Ltd is registered in England and Wales (Company
          Number: 16794792). Registered office: Arum House, 21 Mill Rise,
          Robertsbridge, East Sussex, England, TN32 5EF. (“the Company”)
        </p>{" "}
        <h3>2. Referral Scheme Overview</h3>
        <p>
          {" "}
          The Ava Rose Mortgages Ltd Referral Scheme (“the Scheme”) allows
          eligible individuals to receive a £50 Amazon voucher for referring a
          new client to Ava Rose Mortgages Ltd, subject to these Terms &
          Conditions.{" "}
        </p>{" "}
        <h3> 3. Eligibility</h3>{" "}
        <p> 3.1 The Scheme is open to UK residents aged 18 years or over.</p>
        <p>
          {" "}
          3.2 Employees, contractors, appointed representatives, or immediate
          family members of the Company are eligible to participate.
        </p>
        <p>
          3.3 The Company reserves the right to refuse or withhold rewards where
          it reasonably believes the Scheme is being abused, manipulated, or
          used fraudulently.
        </p>
        <h3> 4. Qualifying Referral</h3> <p>4.1 A referral qualifies where:</p>
        <p>
          {" "}
          ● The referred individual is a new client to Ava Rose Mortgages Ltd;
          <br /> ● The referred individual has not previously made an enquiry
          with the Company within the last 1 year;
          <br /> ● The referred individual completes a mortgage application
          and/or completes mortgage business through the Company; and <br />●
          The referred individual confirms the name of the referrer at the point
          of enquiry or application.
        </p>
        <p>
          4.2 Referrals must be submitted in accordance with the referral
          process set out by the Company.
        </p>
        <p>4.3 Self-referrals are not permitted.</p>
        <h3>5. Reward</h3>
        <p>
          5.1 Subject to these Terms & Conditions, the referrer will receive one
          £50 Amazon voucher for each qualifying referral.
        </p>
        <p>
          5.2 The voucher will be issued within 14 days of the qualifying
          criteria being met.
        </p>
        <p>
          5.3 Rewards are non-transferable, non-exchangeable, and no cash
          alternative will be offered.
        </p>
        <p>
          5.4 The Company reserves the right to substitute the reward with an
          alternative of equal or greater value where necessary.
        </p>
        <h3>6. Advertising and Promotion</h3>
        <p>
          6.1 Participants must not make misleading statements about Ava Rose
          Mortgages Ltd, mortgage products, or the Scheme.
        </p>
        <p>
          6.2 Participants must not present themselves as employees, agents, or
          authorised representatives of the Company.
        </p>
        <p>
          6.3 Any social media posts or promotions relating to the Scheme must
          comply with applicable advertising standards and consumer protection
          laws.
        </p>
        <h3>7. Advertising and Promotion</h3>
        <p>
          7.1 Participants must not make misleading statements about Ava Rose
          Mortgages Ltd, mortgage products, or the Scheme.
        </p>
        <p>
          7.2 Participants must not present themselves as employees, agents, or
          authorised representatives of the Company.
        </p>
        <p>
          7.3 Any social media posts or promotions relating to the Scheme must
          comply with applicable advertising standards and consumer protection
          laws.
        </p>
        <h3>8. Data Protection</h3>
        <p>
          8.1 Personal data supplied in connection with the Scheme will be
          processed in accordance with applicable UK data protection legislation
          and the Company’s Privacy Policy.
        </p>{" "}
        <p>
          8.2 Participants should ensure they have permission from any
          individual before sharing their contact details with the Company.
        </p>
        <p>
          8.3 The Company may contact referred individuals in connection with
          mortgage and protection services offered by Ava Rose Mortgages Ltd.
        </p>
        <h3>9. Tax Liability</h3>
        <p>
          {" "}
          9.1 Participants are responsible for any personal tax liability
          arising from receipt of rewards under the Scheme.
        </p>
        <h3>10. Amendment, Suspension or Withdrawal</h3>
        <p>
          10.1 The Company reserves the right to amend, suspend, or withdraw the
          Scheme at any time without prior notice where reasonably necessary.
        </p>{" "}
        <p>
          10.2 Any changes to these Terms & Conditions will be published on the
          Ava Rose Mortgages Ltd website.
        </p>{" "}
        <h3>11. Liability</h3>
        <p>
          11.1 To the fullest extent permitted by law, the Company accepts no
          liability for:
        </p>
        <p>
          ● Any loss, damage, or disappointment arising from participation in
          the Scheme;
          <br /> ● Any delayed, lost, or incomplete referrals; <br />● Any
          technical or administrative issues affecting the operation of the
          Scheme.
        </p>
        <p>
          Nothing in these Terms excludes liability for death or personal injury
          caused by negligence or any liability which cannot legally be
          excluded.
        </p>
        <h3>12. Governing Law</h3>
        <p>
          These Terms & Conditions are governed by the laws of England and Wales
          and subject to the exclusive jurisdiction of the courts of England and
          Wales.
        </p>
        {/* <h3></h3>
        <p></p> */}
      </div>
    </>
  );
}

export default TermsAndConditionsPage;
